export var ActionOption;
(function (ActionOption) {
    ActionOption["Refer"] = "REFERRAL";
    ActionOption["Order"] = "SLEEP_STUDY";
})(ActionOption || (ActionOption = {}));
export var StudyType;
(function (StudyType) {
    StudyType["PSG"] = "PSG";
    StudyType["HST"] = "HST";
})(StudyType || (StudyType = {}));
